function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
/**********************************************************************************
 *
 * GAME ELEMENTS: BOARD, DICE, CARDS
 *
 * This file contains:
 *
 * 1) some utility functions for scaling games that rely on a game board
 * 2) random dice operations
 * 3) all card-related functions, such as returning cards or
 * calculating their width/height, etc.
 *
 *
 *********************************************************************************/
var GameCards = /*#__PURE__*/function () {
  function GameCards() {
    _classCallCheck(this, GameCards);
  }
  return _createClass(GameCards, [{
    key: "scale",
    value:
    /***********************************************************************************************************
     * Some game modules place elements directly on the board, but when we resize the board (to fit the screen).
     * need to remember the scale ratio in order for the board elements to move with the board
     */
    function scale(x) {
      var y = Math.floor(this.boardRatio * x);
      return y;
    }

    //
    // screen ratio (for determining scaling)
    //
  }, {
    key: "calculateBoardRatio",
    value: function calculateBoardRatio() {
      try {
        var board = this.getBoardElement();
        if (board && this.boardWidth) {
          //Only needed for gameTemplate.scale, for putting game pieces on a game board
          this.boardRatio = board.getBoundingClientRect().width / this.boardWidth;
        }
      } catch (err) {
        console.error("GT [calculateBoardRatio] ERROR: ", err);
      }
    }
  }, {
    key: "getBoardElement",
    value: function getBoardElement() {
      var hex = document.getElementById('hexGrid');
      if (hex && !hex.classList.contains('game-minimap-clone') && !hex.closest('.game-minimap')) {
        return hex;
      }
      return document.querySelector('.gameboard:not(.game-minimap-clone):not(.gameboard-clone)');
    }
  }, {
    key: "prepareBoard",
    value: function prepareBoard(el) {
      el.style.position = 'fixed';
      el.style.margin = '0';
      el.style.right = 'auto';
      el.style.bottom = 'auto';
      el.style.zIndex = '1';
      el.style.transformOrigin = 'top left';
    }
  }, {
    key: "boardDocumentOffset",
    value: function boardDocumentOffset(el) {
      var r = el.getBoundingClientRect();
      return {
        left: r.left,
        top: r.top
      };
    }
  }, {
    key: "saveBoardDocumentOffset",
    value: function saveBoardDocumentOffset(el) {
      if (this.remember_board_position === false) {
        return;
      }
      this.saveGamePreference(this.returnSlug() + '-board-offset', this.boardDocumentOffset(el));
    }

    // left/top are viewport coordinates of the visual top-left.
  }, {
    key: "boardOffsetInWindow",
    value: function boardOffsetInWindow(left, top, visualW, visualH) {
      if (left == null || top == null || !(visualW > 0) || !(visualH > 0)) {
        return false;
      }
      var ix = Math.min(left + visualW, window.innerWidth) - Math.max(left, 0);
      var iy = Math.min(top + visualH, window.innerHeight) - Math.max(top, 0);
      return ix > 160 && iy > 160;
    }
  }, {
    key: "boardFillsView",
    value: function boardFillsView(el) {
      if (!el) {
        return false;
      }
      var r = el.getBoundingClientRect();
      return this.boardOffsetInWindow(r.left, r.top, r.width, r.height);
    }

    // The grid box is much larger than the sectors. A corner of that box can
    // sit in the window while every sector is off-screen.
  }, {
    key: "boardShowsSectors",
    value: function boardShowsSectors(el) {
      if (!el) {
        return false;
      }
      var nodes = el.querySelectorAll('.sector');
      if (!nodes.length) {
        return this.boardFillsView(el);
      }
      for (var _i = 0; _i < nodes.length; _i++) {
        var r = nodes[_i].getBoundingClientRect();
        var ix = Math.min(r.right, window.innerWidth) - Math.max(r.left, 0);
        var iy = Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0);
        if (ix > 48 && iy > 48) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: "moveBoardTo",
    value: function moveBoardTo(el, viewLeft, viewTop) {
      this.prepareBoard(el);
      el.style.left = viewLeft + 'px';
      el.style.top = viewTop + 'px';
    }
  }, {
    key: "placeBoardInWindow",
    value: function placeBoardInWindow(el) {
      if (!el) {
        el = this.getBoardElement();
      }
      if (!el) {
        return;
      }
      this.prepareBoard(el);
      var r = el.getBoundingClientRect();
      var scale = el.offsetWidth ? r.width / el.offsetWidth : 1;
      var visualW = el.offsetWidth * scale;
      var visualH = el.offsetHeight * scale;
      el.style.left = (window.innerWidth - visualW) / 2 + 'px';
      el.style.top = (window.innerHeight - visualH) / 2 + 'px';
      this.saveBoardDocumentOffset(el);
    }
  }, {
    key: "ensureBoardVisible",
    value: function ensureBoardVisible() {
      var el = this.getBoardElement();
      if (!el || this.boardShowsSectors(el)) {
        return;
      }
      var scaled = el.offsetWidth && el.getBoundingClientRect().width / el.offsetWidth > 1.05;
      if (!scaled && this.default_board_scale) {
        this.setBoardScale(this.default_board_scale, false);
      }
      if (!this.boardShowsSectors(el)) {
        this.placeBoardInWindow(el);
      }
    }
  }, {
    key: "getBoardBackdrop",
    value: function getBoardBackdrop() {
      return '';
    }
  }, {
    key: "getBoardState",
    value: function getBoardState() {
      var el = this.getBoardElement();
      if (!el) {
        return null;
      }
      var r = el.getBoundingClientRect();
      var bg = window.getComputedStyle(el).backgroundImage;
      var m = bg && bg !== 'none' ? bg.match(/url\(["']?(.*?)["']?\)/) : null;
      return {
        el: el,
        width: el.offsetWidth,
        height: el.offsetHeight,
        scale: el.offsetWidth ? r.width / el.offsetWidth : 1,
        x: r.left,
        y: r.top,
        image: m ? m[1] : ''
      };
    }
  }, {
    key: "setBoardPosition",
    value: function setBoardPosition(x, y) {
      var el = this.getBoardElement();
      if (!el) {
        return;
      }
      this.moveBoardTo(el, x, y);
      this.saveBoardDocumentOffset(el);
    }
  }, {
    key: "setBoardScale",
    value: function setBoardScale(scale) {
      var save = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var el = this.getBoardElement();
      if (!el) {
        return;
      }
      scale = Math.max(2, Math.min(200, Math.round(Number(scale) || 100)));
      this.prepareBoard(el);
      var before = el.getBoundingClientRect();
      var oldScale = el.offsetWidth ? before.width / el.offsetWidth : 0;
      var cx = window.innerWidth / 2;
      var cy = window.innerHeight / 2;
      var bx = oldScale ? (cx - before.left) / oldScale : 0;
      var by = oldScale ? (cy - before.top) / oldScale : 0;
      el.style.transform = "scale(".concat(scale / 100, ")");
      if (oldScale) {
        var newScale = scale / 100;
        el.style.left = cx - bx * newScale + 'px';
        el.style.top = cy - by * newScale + 'px';
      }
      if (save) {
        this.saveGamePreference(this.returnSlug() + '-board-scale', scale);
        this.saveBoardDocumentOffset(el);
      }
      var input = document.querySelector('#game_board_sizer input');
      if (input) {
        input.value = scale;
        var minZoom = parseFloat(input.min) || 2;
        var maxZoom = parseFloat(input.max) || 200;
        var progress = (scale - minZoom) / (maxZoom - minZoom) * 100;
        input.style.setProperty('--board-scale-progress', "".concat(Math.max(0, Math.min(100, progress)), "%"));
      }
    }
  }, {
    key: "centerBoard",
    value: function centerBoard() {
      var el = document.getElementById('hexGrid') || this.getBoardElement();
      if (!el) {
        return;
      }
      var boardWidth = el.offsetWidth;
      var boardHeight = el.offsetHeight;
      if (!boardWidth || !boardHeight) {
        return;
      }
      var scale = Math.floor(100 * Math.min(window.innerWidth / boardWidth, window.innerHeight / boardHeight));
      this.setBoardScale(scale, false);
      this.placeBoardInWindow(el);
      this.saveGamePreference(this.returnSlug() + '-board-scale', scale);
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////  DICE  /////////////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////////////////////
  }, {
    key: "initializeDice",
    value: function initializeDice() {
      if (this.game.dice === '') {
        if (!this.game.id) {
          this.game.id = this.app.crypto.hash(new Date().getTime() + '');
        }
        this.game.dice = this.app.crypto.hash(this.game.id);
      }
    }
  }, {
    key: "rollDice",
    value: function rollDice() {
      var sides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 6;
      var mycallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      this.game.dice = this.app.crypto.hash(this.game.dice);
      var a = parseInt(this.game.dice.slice(0, 12), 16) % sides;
      if (mycallback != null) {
        mycallback(a + 1);
      } else {
        return a + 1;
      }
    }

    //
    // requests generation of a secure random number for all
    // subsequent rolls.
    //
  }, {
    key: "requestSecureRoll",
    value: function requestSecureRoll() {
      this.game.sroll = 1;
    }
  }, {
    key: "returnDiceImage",
    value: function returnDiceImage(roll) {
      var html = '';
      html += "<span class=\"die\">";
      switch (roll) {
        case 1:
          html += "<svg viewbox=\"0 0 200 200\"><rect fill=\"red\" width=\"200\" height=\"200\" rx=\"25\"/>\n                    <circle fill=\"white\" cx=\"100\" cy=\"100\" r=\"25\"/></svg>";
          break;
        case 2:
          html += "<svg viewbox=\"0 0 200 200\"><rect fill=\"red\" width=\"200\" height=\"200\" rx=\"25\"/>\n                    <circle fill=\"white\" cx=\"66\" cy=\"66\" r=\"25\"/>\n                    <circle fill=\"white\" cx=\"133\" cy=\"133\" r=\"25\"/></svg>";
          break;
        case 3:
          html += "<svg viewbox=\"0 0 200 200\"><rect fill=\"red\" width=\"200\" height=\"200\" rx=\"25\"/>\n                    <circle fill=\"white\" cx=\"50\" cy=\"50\" r=\"25\"/>\n                    <circle fill=\"white\" cx=\"100\" cy=\"100\" r=\"25\"/>\n                    <circle fill=\"white\" cx=\"150\" cy=\"150\" r=\"25\"/></svg>";
          break;
        case 4:
          html += "<svg viewbox=\"0 0 200 200\"><rect fill=\"red\" width=\"200\" height=\"200\" rx=\"25\"/>\n                    <circle fill=\"white\" cx=\"55\" cy=\"55\" r=\"25\"/>\n                    <circle fill=\"white\" cx=\"55\" cy=\"145\" r=\"25\"/>\n                    <circle fill=\"white\" cx=\"145\" cy=\"55\" r=\"25\"/>\n                    <circle fill=\"white\" cx=\"145\" cy=\"145\" r=\"25\"/></svg>";
          break;
        case 5:
          html += "<svg viewbox=\"0 0 200 200\"><rect fill=\"red\" width=\"200\" height=\"200\" rx=\"25\"/>\n                    <circle fill=\"white\" cx=\"50\" cy=\"50\" r=\"25\"/>\n                    <circle fill=\"white\" cx=\"50\" cy=\"150\" r=\"25\"/>\n                    <circle fill=\"white\" cx=\"100\" cy=\"100\" r=\"25\"/>\n                    <circle fill=\"white\" cx=\"150\" cy=\"50\" r=\"25\"/>\n                    <circle fill=\"white\" cx=\"150\" cy=\"150\" r=\"25\"/></svg>";
          break;
        case 6:
          html += "<svg viewbox=\"0 0 200 200\"><rect fill=\"red\" width=\"200\" height=\"200\" rx=\"25\"/>\n                  <circle fill=\"white\" cx=\"55\" cy=\"40\" r=\"25\"/>\n                  <circle fill=\"white\" cx=\"55\" cy=\"100\" r=\"25\"/>\n                  <circle fill=\"white\" cx=\"55\" cy=\"160\" r=\"25\"/>\n                  <circle fill=\"white\" cx=\"145\" cy=\"40\" r=\"25\"/>\n                  <circle fill=\"white\" cx=\"145\" cy=\"100\" r=\"25\"/>\n                  <circle fill=\"white\" cx=\"145\" cy=\"160\" r=\"25\"/></svg>";
          break;
        default:
          html += "<svg viewbox=\"0 0 200 200\"><rect fill=\"red\" width=\"200\" height=\"200\" rx=\"25\"/></svg>";
      }
      html += "</span>";
      return html;
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////  CARDS  ////////////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////////////////////
  }, {
    key: "isFaceDown",
    value: function isFaceDown(card) {
      return false;
    }
  }, {
    key: "returnCardHeight",
    value: function returnCardHeight() {
      var card_width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      return card_width * this.card_height_ratio;
    }
  }, {
    key: "returnCardList",
    value: function returnCardList() {
      var cardarray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var deckid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (cardarray.length === 0) {
        cardarray = this.game.deck[deckid].hand; //Keys to the deck object
      }
      if (cardarray.length === 0) {
        console.warn('GT: No cards to render...');
        return '';
      }
      var html = '';
      if (this["interface"] === 2) {
        //text
        for (var _i2 = 0; _i2 < cardarray.length; _i2++) {
          html += this.returnCardItem(cardarray[_i2], deckid);
        }
        return html;
      } else {
        for (var _i3 = 0; _i3 < cardarray.length; _i3++) {
          html += "<div id=\"".concat(cardarray[_i3], "\" class=\"card ").concat(cardarray[_i3], "\">").concat(this.returnCardImage(cardarray[_i3], deckid), "</div>");
        }
        return html;
      }
    }
  }, {
    key: "returnCardItem",
    value: function returnCardItem(card) {
      var deckid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      card = card.replace(/ /g, '').toLowerCase();
      var c = this.game.deck[deckid].cards[card];

      //Fallback (try discard/remove piles and other decks if card not found)
      for (var z = 0; c == undefined && z < this.game.deck.length; z++) {
        c = this.game.deck[z].cards[cardname];
        if (c == undefined) {
          c = this.game.deck[z].discards[cardname];
        }
        if (c == undefined) {
          c = this.game.deck[z].removed[cardname];
        }
      }
      if (c) {
        return "<li class=\"card\" id=\"".concat(card, "\">").concat(c.name, "</li>");
      } else {
        return "<li class=\"card noncard\" id=\"".concat(card, "\">card not found</li>");
      }
    }
  }, {
    key: "returnCardImage",
    value: function returnCardImage(cardname) {
      var _c$img;
      var deckid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var c = null;
      if (deckid == null) {
        for (var _i4 = 0; _i4 < this.game.deck.length; _i4++) {
          c = this.game.deck[_i4].cards[cardname];
          if (c) {
            deckid = _i4;
            break;
          }
        }
      }
      if (c == null) {
        for (var z = 0; c == null && z < this.game.deck.length; z++) {
          c = this.game.deck[z].cards[cardname];
          if (c == undefined) {
            c = this.game.deck[z].discards[cardname];
          }
          if (c == undefined) {
            c = this.game.deck[z].removed[cardname];
          }
        }
      }

      //
      // this is not a card, it is something like "skip turn" or cancel
      //
      if (c == null) {
        // if this is an object, it might have a returnCardImage() function attached
        // that will give us what we need. try before bailing.
        if (_typeof(cardname) === 'object' && !Array.isArray(cardname) && cardname != null) {
          if (cardname.returnCardImage != null) {
            var x = cardname.returnCardImage();
            if (x) {
              return x;
            }
          }
        }
        return '<div class="noncard">' + cardname + '</div>';
      }
      if (typeof c === 'string') {
        cardname = c;
        c = this.card_library[cardname];
      }
      var suggested_img = this.returnSlug() + '/img/';
      if (((_c$img = c.img) === null || _c$img === void 0 ? void 0 : _c$img.indexOf(suggested_img)) != -1) {
        return "<img class=\"cardimg\" id=\"".concat(cardname, "\" src=\"").concat(c.img, "\" />");
      }
      return "<img class=\"cardimg\" id=\"".concat(cardname, "\" src=\"/").concat(this.returnSlug(), "/img/").concat(c.img, "\" />");
    }

    //
    // returns discarded cards and removes them from discard pile
    //
  }, {
    key: "returnDiscardedCards",
    value: function returnDiscardedCards() {
      var deckidx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var discarded = {};
      deckidx = parseInt(deckidx - 1);
      for (var i in this.game.deck[deckidx].discards) {
        discarded[i] = this.game.deck[deckidx].cards[i];
        delete this.game.deck[deckidx].cards[i];
      }
      this.game.deck[deckidx].discards = {};
      return discarded;
    }
  }, {
    key: "removeCardFromHand",
    value: function removeCardFromHand(card) {
      var moveToDiscard = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      for (var z = 0; z < this.game.deck.length; z++) {
        for (i = 0; i < this.game.deck[z].hand.length; i++) {
          if (this.game.deck[z].hand[i] === card) {
            if (moveToDiscard) {
              this.game.deck[z].discards[card] = this.game.deck[z].cards[card];
            }
            this.game.deck[z].hand.splice(i, 1);
            return;
          }
        }
      }
    }

    /**
     * Convert a hand (array of cards) to the html hand
     */
  }, {
    key: "handToHTML",
    value: function handToHTML(hand) {
      var _this = this;
      var html = "<div class='htmlCards'>";
      hand.forEach(function (card) {
        html += "<img class=\"card\" src=\"".concat(_this.card_img_dir, "/").concat(card, ".png\">");
      });
      html += '</div> ';
      return html;
    }
  }, {
    key: "shuffleDeck",
    value: function shuffleDeck() {
      var deckidx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var new_cards = [];
      var new_keys = [];

      //
      // async_dealing the keys array won't contain keys to unlock
      // the cards, so we make sure the arrays are the same length
      // before shuffling to avoid errors.
      //
      if (this.async_dealing == 1) {
        if (!this.game.deck[deckidx - 1].keys) {
          this.game.deck[deckidx - 1].keys = [];
        }
        while (this.game.deck[deckidx - 1].keys.length < this.game.deck[deckidx - 1].crypt.length) {
          this.game.deck[deckidx - 1].keys.push('');
        }
      }
      var old_crypt = this.game.deck[deckidx - 1].crypt;
      var old_keys = this.game.deck[deckidx - 1].keys;
      var total_cards = this.game.deck[deckidx - 1].crypt.length;
      var total_cards_remaining = total_cards;
      for (var _i5 = 0; _i5 < total_cards; _i5++) {
        // never zero, so subtract 1
        var random_card = this.rollDice(total_cards_remaining) - 1;
        new_cards.push(old_crypt[random_card]);
        new_keys.push(old_keys[random_card]);
        old_crypt.splice(random_card, 1);
        old_keys.splice(random_card, 1);
        total_cards_remaining--;
      }
      this.game.deck[deckidx - 1].crypt = new_cards;
      this.game.deck[deckidx - 1].keys = new_keys;
    }
  }, {
    key: "addPool",
    value: function addPool() {
      var newIndex = this.game.pool.length;
      this.resetPool(newIndex);
    }
  }, {
    key: "addDeck",
    value: function addDeck() {
      var newIndex = this.game.deck.length;
      this.resetDeck(newIndex);
    }
  }, {
    key: "resetPool",
    value: function resetPool() {
      var newIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.game.pool[newIndex] = {};
      this.game.pool[newIndex].cards = {};
      this.game.pool[newIndex].crypt = [];
      this.game.pool[newIndex].keys = [];
      this.game.pool[newIndex].hand = [];
      this.game.pool[newIndex].decrypted = 0;
    }
  }, {
    key: "resetDeck",
    value: function resetDeck() {
      var _this$game$deck$newIn, _this$game$deck$newIn2, _this$game$deck$newIn3;
      var newIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var old_xor = (_this$game$deck$newIn = this.game.deck[newIndex]) === null || _this$game$deck$newIn === void 0 ? void 0 : _this$game$deck$newIn.xor;
      var old_add = (_this$game$deck$newIn2 = this.game.deck[newIndex]) === null || _this$game$deck$newIn2 === void 0 ? void 0 : _this$game$deck$newIn2.to_add;
      var old_remove = (_this$game$deck$newIn3 = this.game.deck[newIndex]) === null || _this$game$deck$newIn3 === void 0 ? void 0 : _this$game$deck$newIn3.to_remove;
      this.game.deck[newIndex] = {};
      this.game.deck[newIndex].cards = {};
      this.game.deck[newIndex].crypt = [];
      this.game.deck[newIndex].keys = [];
      this.game.deck[newIndex].hand = [];
      this.game.deck[newIndex].xor = old_xor || '';
      this.game.deck[newIndex].to_add = old_add || {};
      this.game.deck[newIndex].to_remove = old_remove || {};
      this.game.deck[newIndex].discards = {};
      this.game.deck[newIndex].removed = {};
    }
  }, {
    key: "addCardToDeck",
    value: function addCardToDeck(deckidx, key, card) {
      while (this.game.deck.length < deckidx) {
        this.addDeck();
      }
      this.game.deck[deckidx - 1].to_add[key] = card;
    }
  }, {
    key: "removeCardFromDeck",
    value: function removeCardFromDeck(deckidx, key) {
      while (this.game.deck.length < deckidx) {
        this.addDeck();
      }
      this.game.deck[deckidx - 1].to_remove[key] = 1; // key is what matters
    }
  }, {
    key: "newDeck",
    value: function newDeck() {
      var deck = {};
      deck.cards = {};
      deck.crypt = [];
      deck.keys = [];
      deck.hand = [];
      deck.to_add = {};
      deck.to_remove = {};
      deck.xor = '';
      deck.discards = {};
      deck.removed = {};
      return deck;
    }
  }, {
    key: "returnPokerDeck",
    value: function returnPokerDeck() {
      var deck = {};
      var suits = ['S', 'C', 'H', 'D'];
      var indexCt = 1;
      for (var _i6 = 0; _i6 < 4; _i6++) {
        for (var j = 1; j <= 13; j++) {
          var cardImg = "".concat(suits[_i6]).concat(j);
          deck[indexCt.toString()] = {
            name: cardImg
          }; /*need to make this shit consistent*/
          indexCt++;
        }
      }
      return deck;
    }
  }]);
}();
module.exports = GameCards;